/* DoggyStyle Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-slow-video]').forEach(video => {
    const rate = parseFloat(video.dataset.slowVideo);
    if (!Number.isNaN(rate) && rate > 0) video.playbackRate = rate;
    const startAt = parseFloat(video.dataset.startAt);
    if (!Number.isNaN(startAt) && startAt > 0) {
      const setStartTime = () => {
        if (video.duration && startAt < video.duration) video.currentTime = startAt;
      };
      video.addEventListener('loadedmetadata', setStartTime, { once: true });
      video.addEventListener('canplay', () => video.play().catch(() => {}), { once: true });
    }
  });

  // — Landing product showcase
  const showcase = document.querySelector('[data-product-showcase]');
  if (showcase) {
    const products = {
      calming: {
        kicker: 'Daily calm support',
        title: 'Calming Treats',
        text: 'Soothing daily treats for dogs who need a softer landing during busy days, travel, or bedtime.',
        label: 'Calming',
        cta: 'Shop calming',
        link: '/products/calming-treats',
        color: '#A7CFF5',
        deep: '#3D74A8',
        soft: '#E5F2FF',
        ink: '#285C8D',
        muted: 'rgba(40,92,141,0.78)',
        faint: 'rgba(40,92,141,0.68)'
      },
      joint: {
        kicker: 'Mobility support',
        title: 'Joint Care Treats',
        titleHtml: '<span class="showcase-title__line">Joint Care</span><span class="showcase-title__line">Treats</span>',
        text: 'Functional treats made for everyday movement, comfortable walks, and steady support for active dogs.',
        label: 'Joint Care',
        cta: 'Shop joint care',
        link: '/products/joint-care-treats',
        color: '#F2ECD8',
        deep: '#8F7B4A',
        soft: '#FFF9EA',
        ink: '#6B5A32',
        muted: 'rgba(107,90,50,0.78)',
        faint: 'rgba(107,90,50,0.68)'
      },
      probiotic: {
        kicker: 'Gut health support',
        title: 'Probiotic Treats',
        text: 'Tasty daily bites to support digestion, balance, and happier bellies from breakfast to bedtime.',
        label: 'Probiotic',
        cta: 'Shop probiotic',
        link: '/products/probiotic-treats',
        color: '#CBB7F0',
        deep: '#6F54A8',
        soft: '#F0E8FF',
        ink: '#5B4094',
        muted: 'rgba(91,64,148,0.78)',
        faint: 'rgba(91,64,148,0.68)'
      }
    };

    const title = showcase.querySelector('[data-showcase-title]');
    const kicker = showcase.querySelector('[data-showcase-kicker]');
    const text = showcase.querySelector('[data-showcase-text]');
    const label = showcase.querySelector('[data-showcase-label]');
    const link = showcase.querySelector('[data-showcase-link]');
    const productGraphic = showcase.querySelector('[data-showcase-product]');
    const productImages = showcase.querySelectorAll('[data-product-image]');
    const triggers = showcase.querySelectorAll('[data-product-trigger]');
    const treatLayers = showcase.querySelectorAll('[data-treat-layer]');

    const setProduct = (key) => {
      const product = products[key];
      if (!product) return;

      showcase.style.setProperty('--showcase-color', product.color);
      showcase.style.setProperty('--showcase-deep', product.deep);
      showcase.style.setProperty('--showcase-soft', product.soft);
      showcase.style.setProperty('--showcase-ink', product.ink);
      showcase.style.setProperty('--showcase-muted', product.muted);
      showcase.style.setProperty('--showcase-faint', product.faint);

      if (title) {
        title.classList.toggle('showcase-title--two-line', Boolean(product.titleHtml));
        if (product.titleHtml) title.innerHTML = product.titleHtml;
        else title.textContent = product.title;
      }
      if (kicker) kicker.textContent = product.kicker;
      if (text) text.textContent = product.text;
      if (label) label.textContent = product.label;
      if (link) {
        link.href = product.link;
        link.firstChild.textContent = product.cta + ' ';
      }

      triggers.forEach(trigger => {
        const isActive = trigger.dataset.productTrigger === key;
        trigger.classList.toggle('active', isActive);
        trigger.setAttribute('aria-pressed', String(isActive));
      });

      treatLayers.forEach(layer => {
        layer.classList.toggle('active', layer.dataset.treatLayer === key);
      });

      if (productGraphic) {
        let hasActiveImage = false;
        productImages.forEach(image => {
          const isActiveImage = image.dataset.productImage === key;
          image.classList.toggle('active', isActiveImage);
          if (isActiveImage) hasActiveImage = true;
        });
        productGraphic.classList.toggle('has-product-image', hasActiveImage);
        productGraphic.classList.add('is-changing');
        window.setTimeout(() => productGraphic.classList.remove('is-changing'), 260);
      }
    };

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        showcase.classList.add('has-interacted');
        setProduct(trigger.dataset.productTrigger);
      });
    });
  }

  // — Product page image gallery
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const mainImg = gallery.querySelector('#ProductMainImage');
    const stage = gallery.querySelector('[data-product-gallery-stage]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
    const prev = gallery.querySelector('[data-product-gallery-prev]');
    const next = gallery.querySelector('[data-product-gallery-next]');
    let activeIndex = thumbs.findIndex(thumb => thumb.classList.contains('active'));
    let touchStartX = 0;
    let touchStartY = 0;

    if (!mainImg || !thumbs.length) return;
    if (activeIndex < 0) activeIndex = 0;

    const setImage = (index) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const activeThumb = thumbs[activeIndex];
      if (!activeThumb) return;

      mainImg.src = activeThumb.dataset.src;
      mainImg.alt = activeThumb.dataset.alt || '';

      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('active', thumbIndex === activeIndex);
      });
    };

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => setImage(thumbIndex));
    });

    prev?.addEventListener('click', () => setImage(activeIndex - 1));
    next?.addEventListener('click', () => setImage(activeIndex + 1));

    stage?.addEventListener('touchstart', event => {
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    stage?.addEventListener('touchend', event => {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      setImage(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
    }, { passive: true });
  });

  // — Product details accordion
  document.querySelectorAll('.product-details-panel').forEach(panel => {
    const cards = Array.from(panel.querySelectorAll('.product-detail-card'));

    cards.forEach(card => {
      card.addEventListener('toggle', () => {
        if (!card.open) return;

        cards.forEach(otherCard => {
          if (otherCard !== card) otherCard.open = false;
        });
      });
    });
  });

  // — Product comparison expandable rows
  document.querySelectorAll('.comparison-table').forEach(table => {
    const rows = Array.from(table.querySelectorAll('[data-comparison-row]'));

    const setRow = (row, isOpen) => {
      const toggle = row.querySelector('[data-comparison-toggle]');
      const detail = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
      const icon = toggle ? toggle.querySelector('.comparison-table__toggle-icon') : null;

      row.classList.toggle('is-open', isOpen);
      if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));
      if (detail) detail.hidden = !isOpen;
      if (icon) icon.textContent = isOpen ? '\u2212' : '+';
    };

    rows.forEach(row => {
      const toggle = row.querySelector('[data-comparison-toggle]');
      if (!toggle) return;

      const handleToggle = () => {
        const nextOpen = toggle.getAttribute('aria-expanded') !== 'true';
        rows.forEach(otherRow => setRow(otherRow, false));
        setRow(row, nextOpen);
      };

      toggle.addEventListener('click', event => {
        event.stopPropagation();
        handleToggle();
      });

      row.addEventListener('click', handleToggle);
    });
  });

  // — Animated percentage counters
  document.querySelectorAll('[data-counter-section]').forEach(section => {
    const counters = Array.from(section.querySelectorAll('[data-counter-value]'));
    if (!counters.length) return;

    const animateCounters = () => {
      counters.forEach(counter => {
        const target = parseInt(counter.dataset.counterValue, 10) || 0;
        const duration = 1100;
        const startTime = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - startTime) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = Math.round(target * eased);
          const progressEl = counter.closest('[data-counter-progress]');
          counter.textContent = String(value);
          if (progressEl) progressEl.style.setProperty('--progress', `${value}%`);
          if (progress < 1) requestAnimationFrame(tick);
        };

        counter.textContent = '0';
        const progressEl = counter.closest('[data-counter-progress]');
        if (progressEl) progressEl.style.setProperty('--progress', '0%');
        requestAnimationFrame(tick);
      });
    };

    const counterObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        animateCounters();
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35 });

    counterObserver.observe(section);
    section.addEventListener('mouseenter', animateCounters);
    section.addEventListener('focusin', animateCounters);
  });

  // — Qty controls
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-control').querySelector('.qty-input');
      if (!input) return;
      const min = this.closest('.cart-item-qty') ? 0 : 1;
      let val = parseInt(input.value) || 1;
      if (this.classList.contains('qty-plus')) val++;
      else if (this.classList.contains('qty-minus')) val = Math.max(min, val - 1);
      input.value = val;
    });
  });

  const updateCartCount = (itemCount) => {
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = itemCount;
      return;
    }

    const icon = document.querySelector('.cart-icon');
    if (!icon || itemCount <= 0) return;
    const badge = document.createElement('span');
    badge.className = 'cart-count';
    badge.textContent = itemCount;
    icon.appendChild(badge);
  };

  let freeDeliveryTimer;
  const showFreeDeliveryPopup = () => {
    let popup = document.querySelector('[data-free-delivery-popup]');
    if (!popup) {
      popup = document.createElement('div');
      popup.className = 'free-delivery-popup';
      popup.dataset.freeDeliveryPopup = '';
      popup.setAttribute('role', 'status');
      popup.setAttribute('aria-live', 'polite');
      popup.innerHTML = `
        <button class="free-delivery-popup__close" type="button" aria-label="Close">&times;</button>
        <strong>Free delivery</strong>
        <span>on orders over £20</span>
      `;
      document.body.appendChild(popup);
      popup.querySelector('button')?.addEventListener('click', () => popup.classList.remove('is-visible'));
    }

    window.clearTimeout(freeDeliveryTimer);
    popup.classList.add('is-visible');
    freeDeliveryTimer = window.setTimeout(() => {
      popup.classList.remove('is-visible');
    }, 4200);
  };

  document.querySelectorAll('.product-form, .collection-product__form').forEach(form => {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const addButton = this.querySelector('[type="submit"]');
      if (addButton?.disabled || addButton?.classList.contains('disabled')) return;

      const quantity = parseInt(this.querySelector('[name="quantity"]')?.value, 10) || 1;
      const originalText = addButton?.textContent;
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Adding...';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(this),
        });
        if (!response.ok) throw new Error('Add to cart failed');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        if (quantity === 1) showFreeDeliveryPopup();

        if (addButton) {
          addButton.textContent = 'Added';
          window.setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = originalText || 'Add to cart';
          }, 1600);
        }
      } catch (err) {
        console.error('Add to cart failed:', err);
        if (addButton) {
          addButton.textContent = 'Try again';
          window.setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = originalText || 'Add to cart';
          }, 1600);
        }
      }
    });
  });

  // — Quick add to cart (AJAX)
  document.querySelectorAll('.quick-add').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      const productId = this.dataset.productId;
      if (!productId) return;

      this.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: productId, quantity: 1 }),
        });
        if (res.ok) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          updateCartCount(cart.item_count);
          showFreeDeliveryPopup();
        }
      } catch (err) {
        console.error('Quick add failed:', err);
      }

      setTimeout(() => {
        this.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/><line x1="12" y1="10" x2="12" y2="16"/><line x1="9" y1="13" x2="15" y2="13"/></svg>';
      }, 2000);
    });
  });

  // — Product bundle builder
  document.querySelectorAll('[data-bundle-builder]').forEach(builder => {
    const packs = Array.from(builder.querySelectorAll('[data-bundle-pack]'));
    const products = Array.from(builder.querySelectorAll('[data-bundle-product]'));
    const status = builder.querySelector('[data-bundle-status]');
    const total = builder.querySelector('[data-bundle-total]');
    const add = builder.querySelector('[data-bundle-add]');
    let packSize = 2;
    let discount = 10;

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
      } catch (err) {
        return `£${(cents / 100).toFixed(2)}`;
      }
    };

    const getSelectedCount = () => products.reduce((sum, item) => sum + (parseInt(item.dataset.count, 10) || 0), 0);
    const getSubtotal = () => products.reduce((sum, item) => {
      const count = parseInt(item.dataset.count, 10) || 0;
      const price = parseInt(item.dataset.price, 10) || 0;
      return sum + (count * price);
    }, 0);
    const getDiscountedPrice = (price) => Math.ceil(price * (100 - discount) / 100);
    const getDiscountedTotal = () => products.reduce((sum, item) => {
      const count = parseInt(item.dataset.count, 10) || 0;
      const price = parseInt(item.dataset.price, 10) || 0;
      return sum + (count * getDiscountedPrice(price));
    }, 0);

    const render = () => {
      const selected = getSelectedCount();
      const subtotal = getSubtotal();
      const discounted = getDiscountedTotal();
      const saving = subtotal - discounted;

      products.forEach(item => {
        const count = parseInt(item.dataset.count, 10) || 0;
        const countEl = item.querySelector('[data-bundle-count]');
        const plus = item.querySelector('[data-bundle-plus]');
        const minus = item.querySelector('[data-bundle-minus]');
        const unitPrice = item.querySelector('[data-bundle-unit-price]');
        const price = parseInt(item.dataset.price, 10) || 0;
        const discountedUnit = getDiscountedPrice(price);
        if (countEl) countEl.textContent = count;
        if (plus) plus.disabled = selected >= packSize;
        if (minus) minus.disabled = count <= 0;
        if (unitPrice) unitPrice.textContent = `${formatMoney(discountedUnit)} each`;
      });

      if (status) {
        status.textContent = selected === packSize
          ? `Bundle ready - you save ${formatMoney(saving)}`
          : `Choose ${packSize - selected} more`;
      }
      if (total) total.textContent = selected > 0 ? formatMoney(discounted) : formatMoney(0);
      if (add) add.disabled = selected !== packSize;
    };

    packs.forEach(pack => {
      pack.addEventListener('click', () => {
        packSize = parseInt(pack.dataset.bundlePack, 10) || 2;
        discount = parseInt(pack.dataset.discount, 10) || 0;
        packs.forEach(item => {
          const isActive = item === pack;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });

        let selected = getSelectedCount();
        [...products].reverse().forEach(item => {
          while (selected > packSize && (parseInt(item.dataset.count, 10) || 0) > 0) {
            item.dataset.count = String((parseInt(item.dataset.count, 10) || 0) - 1);
            selected--;
          }
        });
        render();
      });
    });

    products.forEach(item => {
      item.querySelector('[data-bundle-plus]')?.addEventListener('click', () => {
        if (getSelectedCount() >= packSize) return;
        item.dataset.count = String((parseInt(item.dataset.count, 10) || 0) + 1);
        render();
      });

      item.querySelector('[data-bundle-minus]')?.addEventListener('click', () => {
        item.dataset.count = String(Math.max(0, (parseInt(item.dataset.count, 10) || 0) - 1));
        render();
      });
    });

    add?.addEventListener('click', async () => {
      const items = products
        .map(item => ({
          id: Number(item.dataset.variantId),
          quantity: parseInt(item.dataset.count, 10) || 0,
          properties: { 'Bundle saving': `${discount}%` },
        }))
        .filter(item => item.id && item.quantity > 0);

      if (items.length === 0 || getSelectedCount() !== packSize) return;

      add.disabled = true;
      add.textContent = 'Adding...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('Bundle add failed');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) cartCount.textContent = cart.item_count;
        add.textContent = 'Added';
        window.setTimeout(() => {
          add.textContent = 'Add bundle';
          render();
        }, 1800);
      } catch (err) {
        console.error('Bundle add failed:', err);
        add.textContent = 'Try again';
        window.setTimeout(() => {
          add.textContent = 'Add bundle';
          render();
        }, 1800);
      }
    });

    render();
  });

  // — Review gallery expand/collapse
  document.querySelectorAll('[data-reviews-toggle]').forEach(button => {
    const section = button.closest('.reviews-showcase');
    const grid = section ? section.querySelector('[data-reviews-grid]') : null;
    const label = button.querySelector('[data-reviews-toggle-label]');
    const icon = button.querySelector('[data-reviews-toggle-icon]');

    if (!grid) return;

    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !isExpanded;

      grid.classList.toggle('is-collapsed', !nextExpanded);
      button.setAttribute('aria-expanded', String(nextExpanded));

      if (label) label.textContent = nextExpanded ? 'Hide reviews' : 'View more reviews';
      if (icon) icon.textContent = nextExpanded ? '↑' : '↓';
      if (nextExpanded) {
        grid.querySelectorAll('.review-card').forEach(card => card.classList.add('revealed'));
      }
    });
  });

  // — Homepage review pager
  document.querySelectorAll('[data-reviews-pager]').forEach(grid => {
    const section = grid.closest('.reviews-showcase');
    const prev = section ? section.querySelector('[data-reviews-page-prev]') : null;
    const next = section ? section.querySelector('[data-reviews-page-next]') : null;
    const status = section ? section.querySelector('[data-reviews-page-status]') : null;
    const cards = Array.from(grid.querySelectorAll('.review-card'));
    const pageSize = 4;
    const pageCount = Math.max(1, Math.ceil(cards.length / pageSize));
    let page = 0;

    if (!prev || !next || cards.length === 0) return;

    const render = () => {
      const start = page * pageSize;
      const end = start + pageSize;

      cards.forEach((card, index) => {
        card.hidden = index < start || index >= end;
      });

      prev.disabled = page === 0;
      next.disabled = page >= pageCount - 1;

      if (status) {
        status.textContent = `${page + 1} / ${pageCount}`;
      }
    };

    prev.addEventListener('click', () => {
      page = Math.max(0, page - 1);
      render();
    });

    next.addEventListener('click', () => {
      page = Math.min(pageCount - 1, page + 1);
      render();
    });

    render();
  });

  // — Collection product carousel
  document.querySelectorAll('[data-collection-carousel]').forEach(carousel => {
    const cards = Array.from(carousel.querySelectorAll('[data-collection-card]'));
    const tabs = Array.from(carousel.querySelectorAll('[data-collection-tab]'));
    const select = carousel.querySelector('[data-collection-select]');
    const treatLayers = carousel.querySelectorAll('[data-collection-treat-layer]');
    const prev = carousel.querySelector('[data-collection-prev]');
    const next = carousel.querySelector('[data-collection-next]');
    let activeIndex = cards.findIndex(card => card.classList.contains('is-active'));
    let treatFallTimer;
    let treatSettleTimer;

    if (!cards.length) return;
    if (activeIndex < 0) activeIndex = 0;

    const setTreatLayer = (palette) => {
      treatLayers.forEach(layer => {
        layer.classList.toggle('active', layer.dataset.collectionTreatLayer === palette);
      });
    };

    const animateTreats = (palette) => {
      if (!treatLayers.length) return;

      window.clearTimeout(treatFallTimer);
      window.clearTimeout(treatSettleTimer);
      carousel.classList.remove('is-treat-falling');
      carousel.classList.remove('is-treat-settling');
      void carousel.offsetWidth;
      carousel.classList.add('is-treat-falling');

      treatFallTimer = window.setTimeout(() => {
        setTreatLayer(palette);
        carousel.classList.remove('is-treat-falling');
        carousel.classList.add('is-treat-settling');
      }, 360);

      treatSettleTimer = window.setTimeout(() => {
        carousel.classList.remove('is-treat-settling');
      }, 980);
    };

    const setActive = (index, animate = true) => {
      const nextActiveIndex = (index + cards.length) % cards.length;
      const activeChanged = nextActiveIndex !== activeIndex;
      activeIndex = nextActiveIndex;
      const prevIndex = (activeIndex - 1 + cards.length) % cards.length;
      const nextIndex = (activeIndex + 1) % cards.length;
      const palette = cards[activeIndex].dataset.collectionPalette || 'calming';

      carousel.classList.toggle('is-joint', palette === 'joint');
      carousel.classList.toggle('is-probiotic', palette === 'probiotic');

      if (animate && activeChanged) animateTreats(palette);
      else setTreatLayer(palette);

      cards.forEach((card, cardIndex) => {
        card.classList.toggle('is-active', cardIndex === activeIndex);
        card.classList.toggle('is-prev', cardIndex === prevIndex && cardIndex !== activeIndex);
        card.classList.toggle('is-next', cardIndex === nextIndex && cardIndex !== activeIndex);
        card.classList.toggle('is-hidden', cardIndex !== activeIndex && cardIndex !== prevIndex && cardIndex !== nextIndex);
      });

      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      if (select) select.value = String(activeIndex);
    };

    prev?.addEventListener('click', () => setActive(activeIndex - 1));
    next?.addEventListener('click', () => setActive(activeIndex + 1));

    tabs.forEach(tab => {
      tab.addEventListener('click', () => setActive(parseInt(tab.dataset.collectionTab, 10) || 0));
    });

    select?.addEventListener('change', () => setActive(parseInt(select.value, 10) || 0));

    cards.forEach(card => {
      const link = card.querySelector('[data-collection-card-link]');
      link?.addEventListener('click', event => {
        const cardIndex = parseInt(card.dataset.collectionIndex, 10) || 0;
        if (cardIndex !== activeIndex) {
          event.preventDefault();
          setActive(cardIndex);
        }
      });
    });

    setActive(activeIndex, false);
  });

  // — Cart quantity update
  document.querySelectorAll('.cart-item-qty').forEach(control => {
    const input = control.querySelector('input');
    const item = control.closest('[data-cart-line]');
    const line = parseInt(item?.dataset.cartLine, 10);
    if (!input || !line) return;

    let updateTimer;
    const updateCartLine = async () => {
      const quantity = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = quantity;
      control.classList.add('is-updating');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (err) {
        console.error('Cart update failed:', err);
        control.classList.remove('is-updating');
      }
    };

    control.querySelectorAll('.qty-btn').forEach(button => {
      button.addEventListener('click', () => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(updateCartLine, 180);
      });
    });

    input.addEventListener('change', () => {
      window.clearTimeout(updateTimer);
      updateCartLine();
    });
  });

  // — Scroll-triggered reveal animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card:not([data-collection-card]), .review-card, .ingredient-item, .founder-story__content').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
    observer.observe(el);
  });

  document.addEventListener('animationend', () => {}, false);

  // — FAQ accordion
  document.querySelectorAll('.faq-item__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const answer = item ? item.querySelector('.faq-item__answer') : null;
      if (!answer) return;

      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      answer.hidden = isOpen;

      const icon = btn.querySelector('.faq-item__icon');
      if (icon) icon.textContent = isOpen ? '+' : '–';
    });
  });

  // Add revealed class styles dynamically
  const style = document.createElement('style');
  style.textContent = '.revealed { opacity: 1 !important; transform: none !important; }';
  document.head.appendChild(style);

});
